<template>
  <div>
    <loading-screen :is-loading="isLoading"></loading-screen>


    <b-modal id="referrer-modal" ok-title="Continue" cancel-disabled @ok="confirm_referrer"
             title="YourSynchronicity Journey">
      <label>Who is your referrer: (if you dont have one, press Continue.)</label>
      <input v-model="referrer" type="text" class="form-control"/>

    </b-modal>

  </div>
</template>

<script>
    import * as qs from "postcss";
    import axios from "axios";
    import queryString from 'query-string';
    import {eventBus} from '../main'

    import Loader from "./Loader";

    export default {
        name: "authentication",
        data() {
            return {
                isLoading: true,
                referrer: '',
                dict_token_tmp: [],
                jwtIdToken: '',
                jwtYsyIdToken: '',
            }
        },
        components: {
            eventBus,
            'loading-screen': Loader
        },
        created() {
            this.isLoading = true;
            console.log("Authentication component");
            this.initYourSynchronicityAuthentication()
        },
        methods: {
            async initYourSynchronicityAuthentication() {
                if ("code" in this.$route.query) {
                    this.isLoading = true;
                    console.log('Connection with Cognito UI', this.$route.query.code);
                    const path = 'https://upgrademe.auth.eu-west-1.amazoncognito.com/oauth2/token';
                    const code = this.$route.query.code;
                    var self = this;
                    var basicAuth = 'Basic ' + btoa(this.API_KEY_CLIENT_VUE + ':' + this.API_SECRET_KEY_VUE);
                    var data = {
                        'grant_type': 'authorization_code',
                        'client_id': this.API_KEY_CLIENT_VUE,
                        'code': code,
                        'redirect_uri': this.CALLBACK_UI_COGNITO + "/authentication",
                    };

                    this.jwtIdToken = await axios.post(path, queryString.stringify(data), {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Authorization': basicAuth
                        }
                    }).then(res => {
                        console.log(res.data);
                        localStorage.id_token = res.data.id_token;
                        localStorage.refresh_token = res.data.refresh_token;
                        this.isLoading = false;
                        return res.data.id_token
                    }).catch(function (error) {
                        self.isLoading = false;
                        console.log('Error on Authentication');
                        return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlcnJvciI6IlVzZSBjb2RlIGV4cGlyZWQifQ.pQEMnQ3KvZ194JaCGEkj7DYLMhtHYsGCZP9YBB49qH8'
                    });

                    this.parse_jwt_token(this.jwtIdToken)
                } else if ("ysyCode" in this.$route.query && "ysyTag" in this.$route.query) {
                    let self = this;
                    this.isLoading = true;
                    console.log('Requesting the JWT');
                    localStorage.clear();
                    // self.$store.dispatch('logout');
                    let ysy_decode_path = this.BACKEND_YSY + "/admin/bridge-to-ysy";
                    let ysy_data = {
                        'ysyCode': this.$route.query.ysyCode,
                        'ysyTag': this.$route.query.ysyTag,
                        'ysyDecode': 'true'
                    };

                    this.jwtYsyIdToken = await axios.post(ysy_decode_path, ysy_data).then(res => {
                        localStorage.id_token = res.data.IdToken;
                        localStorage.refresh_token = res.data.RefreshToken;
                        this.isLoading = false;
                        return "IdToken" in res.data ? res.data.IdToken : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlcnJvciI6IlVzZSBjb2RlIGV4cGlyZWQifQ.pQEMnQ3KvZ194JaCGEkj7DYLMhtHYsGCZP9YBB49qH8'
                    }).catch(function (error) {
                        self.isLoading = false;
                        console.log('Error on Authentication');
                        return 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlcnJvciI6IlVzZSBjb2RlIGV4cGlyZWQifQ.pQEMnQ3KvZ194JaCGEkj7DYLMhtHYsGCZP9YBB49qH8'
                    });

                    this.parse_jwt_token(this.jwtYsyIdToken)
                } else {
                    console.log('Else no query parameter');
                    this.$router.push({name: 'Landing'})
                }
            },
            confirm_referrer() {
                const dict_token = this.dict_token_tmp;
                console.log("generate the license key");
                if (this.referrer === '') {
                    this.referrer = 'YSY';

                }

                console.log("Referrer is", this.referrer)
                const path = this.BACKEND_YSY + "/unlock-account";
                let headers = {
                    'Content-type': 'application/json',
                    'Authorization': `Bearer ${localStorage.id_token}`
                };
                this.$http
                    .post(path, {
                        username: dict_token['cognito:username'],
                        referrer: this.referrer.toUpperCase(),
                        unlock_code: "generate"
                    }, {headers})
                    .then(res => {
                            console.log(res)
                        }
                    ).catch(error => {
                        console.log(error)
                    }
                );
                const payload = {
                    "user": dict_token['cognito:username'],
                    "emailLinkedin": 'custom:email_linkedin' in dict_token ? dict_token['custom:email_linkedin'] : 'NaN',
                    "role": 'custom:role' in dict_token ? dict_token['custom:role'] : 'user',
                    "lastWithdrawRun": 'custom:lastWithdrawRun' in dict_token ? dict_token['custom:lastWithdrawRun'] : '1549580400',
                    "haveAccount": 'custom:haveAccount' in dict_token ? (dict_token['custom:haveAccount'] === 'true') : false,
                    "isBlocked": 'custom:isBlocked' in dict_token ? (dict_token['custom:isBlocked'] === 'true') : true,
                    "referrer": 'custom:referrer' in dict_token ? dict_token['custom:referrer'] : 'YSY',
                    "automatedYsyActions": 'custom:automatedYsyActions' in dict_token ? dict_token['custom:automatedYsyActions'].split('@YSY@') : [],
                    "notificationActionYsy": 'custom:notifyYsyActions' in dict_token ? dict_token['custom:notifyYsyActions'].split('@YSY@') : [],
                    "emailInstagram": 'custom:email_instagram' in dict_token ? dict_token['custom:email_instagram'].split(',') : [],
                    "haveAccountInstagram": 'custom:haveAccountInstagram' in dict_token ? (dict_token['custom:haveAccountInstagram'] === 'true') : false,
                };
                let dict_configuration_limit = {
                    'connection': {'count': 0, 'limit': 1},
                    'message': {'count': 0, 'limit': 1},
                    'getContactInformation': {'count': 0, 'limit': 2}
                };

                this.$store.commit('setDictConfigurationLimit', dict_configuration_limit);
                this.$store.commit('auth_success', payload);
                this.$store.commit('setReferrer', this.referrer.toUpperCase());
                this.$router.push({name: 'Profile'})

            },
            parse_jwt_token(token) {
                const dict_token = JSON.parse(atob(token.split('.')[1]));
                // console.log(dict_token);

                if ("error" in dict_token) {
                    this.$router.push({name: 'Landing'})
                    return
                }
                // generate license
                if (!('custom:isBlocked' in dict_token)) {
                    this.$bvModal.show('referrer-modal');
                    this.dict_token_tmp = dict_token;
                    // this.confirm_referrer(dict_token)
                    return
                }
                const payload = {
                    "user": dict_token['cognito:username'],
                    "emailLinkedin": 'custom:email_linkedin' in dict_token ? dict_token['custom:email_linkedin'] : 'NaN',
                    "role": 'custom:role' in dict_token ? dict_token['custom:role'] : 'user',
                    "lastWithdrawRun": 'custom:lastWithdrawRun' in dict_token ? dict_token['custom:lastWithdrawRun'] : '1549580400',
                    "haveAccount": 'custom:haveAccount' in dict_token ? (dict_token['custom:haveAccount'] === 'true') : false,
                    "isBlocked": 'custom:isBlocked' in dict_token ? (dict_token['custom:isBlocked'] === 'true') : true,
                    "referrer": 'custom:referrer' in dict_token ? dict_token['custom:referrer'] : 'YSY',
                    "automatedYsyActions": 'custom:automatedYsyActions' in dict_token ? dict_token['custom:automatedYsyActions'].split('@YSY@') : [],
                    "notificationActionYsy": 'custom:notifyYsyActions' in dict_token ? dict_token['custom:notifyYsyActions'].split('@YSY@') : [],
                    "emailInstagram": 'custom:email_instagram' in dict_token ? dict_token['custom:email_instagram'].split(',') : [],
                    "haveAccountInstagram": 'custom:haveAccountInstagram' in dict_token ? (dict_token['custom:haveAccountInstagram'] === 'true') : false,
                };
                console.log(payload);
                this.$store.commit('auth_success', payload);
                if (dict_token['cognito:username'] === 'branchofapp') {
                    this.$router.push({name: 'adminysy'});
                    return
                }
                if (dict_token['custom:isBlocked'] === 'true') {
                    this.$router.push({name: 'Profile'})
                } else {
                    this.$router.push({name: 'Dashboard'})
                }
            }
        }
    }
</script>

<style scoped>
  #ysyloading-wrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  #ysyloading-text {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    color: rgb(20, 121, 60);
    width: 100px;
    height: 30px;
    margin: -7px 0 0 -45px;
    text-align: center;
    font-family: 'PT Sans Narrow', sans-serif;
    font-size: 20px;
  }

  #ysyloading-content {
    display: block;
    position: relative;
    left: 50%;
    top: 50%;
    width: 170px;
    height: 170px;
    margin: -85px 0 0 -85px;
    border: 3px solid #F00;
  }

  #ysyloading-content {
    border: 3px solid transparent;
    border-top-color: rgb(121, 61, 185);
    border-bottom-color: rgb(121, 61, 185);
    border-radius: 50%;
    -webkit-animation: loader 2s linear infinite;
    -moz-animation: loader 2s linear infinite;
    -o-animation: loader 2s linear infinite;
    animation: loader 2s linear infinite;
  }

  @keyframes loader {
    0% {
      -webkit-transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>
